/* eslint-disable no-inner-declarations */
import timelineFunctions from "../lib/timelineFunctions";

let unitHeight;
let graphic;
let data_save;
let canvas_save;
let personFocused;
let activeSpacing;
let renderOffset;
let calcSpacing;
let personFocusCallback;

function graphSetup(data, canvas, onPersonFocus) {
  data_save = data;
  canvas_save = canvas;
  graphic = [];
  const ctx = canvas.getContext("2d");
  ctx.canvas.width = canvas.offsetWidth;
  ctx.canvas.height = canvas.offsetHeight;

  canvas_save.addEventListener("mousemove", handleMouseEvents);
  canvas_save.addEventListener("mouseleave", handleMouseEvents);
  personFocusCallback = onPersonFocus;

  calcSpacing = ctx.canvas.offsetWidth / data_save.length;
  activeSpacing = calcSpacing == 0 ? ctx.canvas.width : calcSpacing;
  renderOffset =
    Math.round(((Math.ceil(activeSpacing) - activeSpacing) * data.length) / 2) / 2;

  const era_startDate = new Date(
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "year",
      "start",
      "earliest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "month",
      "start",
      "earliest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "day",
      "start",
      "earliest",
    ),
  );
  const era_endDate = new Date(
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "year",
      "end",
      "latest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "month",
      "end",
      "latest",
    ),
    timelineFunctions.extractFromDate(
      timelineFunctions.customNode_entireEra,
      "day",
      "end",
      "latest",
    ),
  );
  unitHeight =
    canvas.offsetHeight /
    ((timelineFunctions.monthDiff(era_startDate, era_endDate) / 12) * 4);

  //Add data to array
  data.forEach((person, personIndex) => {
    graphic.push([]);

    person.stops.forEach((entry) => {
      const start = timelineFunctions.quartalsSinceEraStart(entry.start_earliest);
      const end = timelineFunctions.quartalsSinceEraStart(entry.end_latest);
      for (let c = 0; c <= end - start; c++) {
        graphic[personIndex].push({
          start: start,
          end: end,
        });
      }
    });
  });

  drawTimeline(data, canvas);
}

function drawTimeline(data, canvas) {
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  //Draw the scala
  ctx.fillStyle = "#777";
  for (
    let i = 0;
    i <=
    timelineFunctions.quartalsSinceEraStart("1859-09-01") -
      timelineFunctions.quartalsSinceEraStart("1793-12-01");
    i++
  )
    ctx.fillRect(
      ctx.canvas.width / 2 - 1.5,
      (timelineFunctions.quartalsSinceEraStart("1793-12-01") + i) * unitHeight,
      3,
      Math.ceil(unitHeight),
    );
  //Draw the graph
  graphic.forEach((person, personIndex) => {
    person.forEach((entry) => {
      if (personIndex == personFocused) ctx.fillStyle = "#8d3333";
      else ctx.fillStyle = `rgb(140, 180, 145)`;
      for (let i = 0; i <= entry.end - entry.start; i++) {
        ctx.fillRect(
          personIndex * activeSpacing + renderOffset,
          (entry.start + i) * unitHeight,
          activeSpacing,
          Math.ceil(unitHeight),
        );
      }
    });
  });
}

function handleMouseEvents(event) {
  const canvasWidth_alt = activeSpacing * data_save.length;

  const currentPersonFocused = Math.floor(
    ((event.clientX - renderOffset - canvas_save.getBoundingClientRect().x) /
      canvasWidth_alt) *
      data_save.length,
  );

  if (currentPersonFocused !== personFocused) {
    personFocused = currentPersonFocused;
    drawTimeline(data_save, canvas_save);

    if (currentPersonFocused >= data_save.length || currentPersonFocused < 0) {
      personFocusCallback(null);
      return;
    }

    const yearsSinceStart = Math.round(event.offsetY / unitHeight) / 4;
    const focusedQuarter = Math.round(event.offsetY / unitHeight) % 4;
    const startMonthOfFocusedQuarter = Math.ceil(focusedQuarter * 3);

    const info = {
      personSlug: data_save[personFocused].person.slug,
      date: new Date(
        timelineFunctions.extractFromDate(
          timelineFunctions.customNode_entireEra,
          "year",
          "start",
          "earliest",
        ) + yearsSinceStart,
        startMonthOfFocusedQuarter,
        1,
      ),
    };

    personFocusCallback(info);
  }
}

function remove() {
  canvas_save.removeEventListener("mousemove", handleMouseEvents);
  canvas_save.removeEventListener("mouseleave", handleMouseEvents);
}

export default {
  handleMouseEvents,
  graphSetup,
  remove,
};
